import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import SprintsIndex from '../../../components/Admin/Sprints/SprintsIndex';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const SprintsIndexContainer = (props) => (
  <ApolloProvider client={client}>
    <SprintsIndex {...props} />
  </ApolloProvider>
);

export default SprintsIndexContainer;


